import { DocumentSearchRegular, WarningRegular, CheckmarkCircleRegular } from '@fluentui/react-icons'
import { CapabilityCard } from '@/components/common/CapabilityCard'
import { PanelShell } from './PanelShell'
import grid from './PanelGrid.module.css'

interface PanelProps {
  onOpenWorkspace: () => void
}

export function EvidencePanel({ onOpenWorkspace }: PanelProps) {
  return (
    <PanelShell
      icon={DocumentSearchRegular}
      title="Evidence"
      subtitle="Understand what signals were observed, and — just as importantly — what evidence is still missing."
      onOpenWorkspace={onOpenWorkspace}
    >
      <div className={grid.grid}>
        <CapabilityCard
          icon={CheckmarkCircleRegular}
          eyebrow="Observed"
          title="Observed signals"
          points={['Surfaces the concrete signals an assessment is based on, with their source domain']}
        />
        <CapabilityCard
          icon={WarningRegular}
          eyebrow="Gaps"
          title="Evidence gaps"
          points={[
            'Flags missing telemetry or unanswered questions that limit investigation scope or confidence',
          ]}
        />
        <CapabilityCard
          icon={DocumentSearchRegular}
          eyebrow="Traceability"
          title="Source-labelled reasoning"
          points={['Findings remain traceable to Sentinel, Defender XDR, Entra ID or Defender for Endpoint']}
        />
      </div>
    </PanelShell>
  )
}
